/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Move } from '@one-thd/sui-icons';
import { useSortable } from '@dnd-kit/sortable';
import PropTypes from 'prop-types';
import { getId } from './dragAndDropHelper';

export const DragHandle = ({ id, groupId, sortableRef }) => {
  const item = getId(id);
  const {
    attributes,
    listeners
  } = useSortable({
    id,
    data: { groupId, item }
  });
  return (
    <Move
      data-testid="MoveIcon"
      ref={sortableRef}
      {...attributes}
      {...listeners}
    />
  );
};

DragHandle.displayName = 'DragHandle';

DragHandle.propTypes = {
  id: PropTypes.string.isRequired,
  groupId: PropTypes.string,
  sortableRef: PropTypes.func
};

DragHandle.defaultProps = {
  sortableRef: null,
  groupId: null
};
